export * from './Rest';
export * from './RequestError';
import { Rest, RestConfig } from './Rest';

export const initRest = (baseConfig: RestConfig = {}) => {
  return new Rest(baseConfig);
};
